<template>
  <span class="auction-time" id="countdown">
    <!-- Consolidating all time units into a single inline span. -->
    <span v-if="!ended" class="countdown-amount">
      <!-- Days: Show if days > 0 -->
      <template v-if="days > 0">
        {{ days | formatTime }} j
      </template>

      <!-- Hours: Show if hours > 0 -->
      <template v-if="hours > 0">
        {{ hours | formatTime }} h
      </template>

      <!-- Minutes: Show only if days == 0 -->
      <template v-if="days == 0">
        {{ minutes | formatTime }} m
      </template>

      <!-- Seconds: Show only if days == 0 and hours == 0 -->
      <template v-if="days == 0 && hours == 0">
        {{ seconds | formatTime }} s
      </template>
    </span>
    
     <span v-else>{{$t('filter.auctionEnded')}}</span>
  </span>
</template>

<script>
export default {
  props: {
    deadline: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      required: true,
    },
    speed: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      currentTime: null,
      timerInterval: null,
    };
  },
  methods: {
    countdown() {
      // Calculate the remaining time in milliseconds.
      // We calculate the difference between the deadline and now, and add the initial duration.
      this.currentTime = Date.parse(this.deadline) - Date.parse(new Date());
      // Add duration in days (converted to ms)
      this.currentTime += 1000 * 60 * 60 * 24 * this.duration; 

      // If time is still remaining, schedule the next countdown update.
      if (this.currentTime > 0) {
        setTimeout(this.countdown, this.speed);
      } else {
        // Auction is over
        this.currentTime = null;
      }
    },
  },
  computed: {
    seconds() {
      // Calculate remaining seconds
      return Math.floor((this.currentTime / 1000) % 60);
    },
    minutes() {
      // Calculate remaining minutes
      return Math.floor((this.currentTime / 1000 / 60) % 60);
    },
    hours() {
      // Calculate remaining hours
      return Math.floor((this.currentTime / (1000 * 60 * 60)) % 24);
    },
    days() {
      // Calculate remaining days
      return Math.floor(this.currentTime / (1000 * 60 * 60 * 24));
    },
    ended() {
      // Calculate remaining days
      return this.currentTime === null;
    },
  },
  mounted() {
    // Start the countdown immediately after the component is mounted
    setTimeout(this.countdown, 1000);
  },
  filters: {
    // Adds a leading zero for single-digit numbers
    formatTime(value) {
      if (value < 10) {
        return "0" + value;
      }
      return value;
    },
  },
};
</script>

<style scoped>
.auction-time {
  display: inline;
}

.countdown-amount {
  font-weight: 400 !important;
  display: inline;
}

/* This rule adds space between the time units to prevent them from merging */
.countdown-amount > * + * {
  margin-left: 0.5rem;
}
</style>